// src/pages/PurchaseAccountLedger/PurchaseAccountLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPurchaseLedgerApi } from "../../apiservice/reports";
import { getAccountByTypeApi } from "../../apiservice/setting";

export const fetchPurchaseAccountLedger = createAsyncThunk(
  "purchaseAccountLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getPurchaseLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchPurchaseAccounts = createAsyncThunk(
  "purchaseAccountLedger/fetchAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_type_id: "purchase_account" });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
